/**
 * ホームトップの生成メニュー（静止画 / 動画）カード。
 * ブランドごとの用語は brandConfig.labels.productShort / scenarioNoun から
 * 自動差し替えされる (例: 商品/案件、シナリオ/絵コンテ)。
 */

import { useNavigate } from 'react-router-dom';
import { brandConfig } from '../../config/brands';
import '../../pages/HomePage.css';

export function HomeHeroMenu() {
  const navigate = useNavigate();
  const { scenarioNoun, attributeMode, scenarioMode } = brandConfig.labels;

  return (
    <section className="home-hero">
      {/* 静止画生成 */}
      <div className="home-gen-card home-gen-card--image" data-guide-step="image-gen-card">
        <div className="home-gen-visual">
          <div className="home-gen-glow" />
          <div className="home-gen-heading">
            <img src="/picture_stack_landscape.svg" alt="" className="home-gen-icon" />
            <h2 className="home-gen-title">静止画生成</h2>
          </div>
          <p className="home-gen-subtitle">かんたんにAI画像生成</p>
        </div>
        <div className="home-gen-body">
          <div className="home-gen-actions">
            <button
              className="home-gen-btn"
              onClick={() => {
                // HypeApp は /studio/image を裸アクセスするとプロンプトモードへ
                // 自動リダイレクトされるため、ボタンの意図を localStorage に表明しておく
                localStorage.setItem('studio_still_image_mode', 'attributes');
                navigate('/studio/image');
              }}
            >
              <img src="/shapes.svg" alt="" className="home-gen-btn-icon" />
              <div className="home-gen-btn-text">
                <span className="home-gen-btn-label">{attributeMode}</span>
                <span className="home-gen-btn-desc">背景・人物・構図を選んでかんたん生成</span>
              </div>
              <span className="home-gen-btn-arrow" aria-hidden="true" />
            </button>
            <button className="home-gen-btn" onClick={() => navigate('/studio/image/prompt')}>
              <img src="/keyboard.svg" alt="" className="home-gen-btn-icon" />
              <div className="home-gen-btn-text">
                <span className="home-gen-btn-label">プロンプト入力モード</span>
                <span className="home-gen-btn-desc">テキストで自由にイメージを指示</span>
              </div>
              <span className="home-gen-btn-arrow" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* 動画生成 */}
      <div className="home-gen-card home-gen-card--video" data-guide-step="video-gen-card">
        <div className="home-gen-visual">
          <div className="home-gen-glow" />
          <div className="home-gen-heading">
            <img src="/video_player_movie.svg" alt="" className="home-gen-icon" />
            <h2 className="home-gen-title">動画生成</h2>
          </div>
          <p className="home-gen-subtitle">動画広告をかんたんに制作</p>
        </div>
        <div className="home-gen-body">
          <div className="home-gen-actions">
            <div className="home-gen-btn-row">
              <button
                className="home-gen-btn home-gen-btn-flex"
                onClick={() => {
                  // 静止画側と同様、/studio/video の裸アクセスはプロンプトモードへ
                  // 自動リダイレクトされるため、属性モードの意図を localStorage に表明
                  localStorage.setItem('studio_scenario_mode', 'attributes');
                  navigate('/studio/video');
                }}
              >
                <img src="/film_line.svg" alt="" className="home-gen-btn-icon" />
                <div className="home-gen-btn-text">
                  <span className="home-gen-btn-label">{scenarioMode}</span>
                  <span className="home-gen-btn-desc">{scenarioNoun}を丸ごと生成</span>
                </div>
                <span className="home-gen-btn-arrow" aria-hidden="true" />
              </button>
              <button className="home-gen-btn home-gen-btn-open" onClick={() => navigate('/studio/video?scenarioBook=1')}>
                <img src="/book_book_pages.svg" alt="" className="home-gen-btn-open-icon" />
                開く
              </button>
            </div>
            <button className="home-gen-btn" onClick={() => navigate('/studio/video/prompt')}>
              <img src="/keyboard.svg" alt="" className="home-gen-btn-icon" />
              <div className="home-gen-btn-text">
                <span className="home-gen-btn-label">プロンプト入力モード</span>
                <span className="home-gen-btn-desc">テキストで{scenarioNoun}を自由に記述</span>
              </div>
              <span className="home-gen-btn-arrow" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
